import { ReactComponent as OOSvg } from './icon_oo.svg';
import styles from './OOLogo.module.scss';

const OOLogoComponent = () => {
  return <OOSvg className={styles.logo} />;
};

export { OOLogoComponent as OOLogo };
